import * as yup from 'yup'

const createCVSourceValidate = yup.object().shape({
    cover_letter_source_name: yup.string().required('Chưa nhập tên nguồn'),
})

export default createCVSourceValidate
